import { render, staticRenderFns } from "./OnboardingMainInformation.vue?vue&type=template&id=13edf5f9&"
import script from "./OnboardingMainInformation.vue?vue&type=script&lang=js&"
export * from "./OnboardingMainInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports